// extracted by mini-css-extract-plugin
module.exports = {"score":"ScoreItem_score__B2-8h","scoreValue":"ScoreItem_scoreValue__2j-Cz","scoreLabels":"ScoreItem_scoreLabels__Inf5h"};